import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import { colorPalette } from '@shared/config/colorsConfig';
import { useI18n } from '@shared/i18n/useI18n';

export const ChatChannelListEmpty = () => {
    const { t } = useI18n();

    return (
        <View className="flex-1 items-center justify-center px-lg">
            <Text className="text-center text-md font-semibold" style={{ color: colorPalette.primary[700] }}>
                {t('screens.chat.list.empty')}
            </Text>
        </View>
    );
};
